import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { FileX2, RefreshCcw, TrendingUp } from "lucide-react";
import { Button } from "@/components/ui/button";
import CreditReportView, { computeScoreDeltas } from "@/components/app/CreditReportView";

export default function AdminCreditReportPanel({ clientId }) {
  const [state, setState] = useState({ report: null, previous: null, total: 0 });
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const { data } = await api.get(`/admin/clients/${clientId}/credit-report`);
      setState(data || { report: null, previous: null, total: 0 });
    } catch (e) { /* ignore */ }
    finally { setLoading(false); }
  };
  useEffect(() => { if (clientId) load(); /* eslint-disable-next-line */ }, [clientId]);

  const deltas = computeScoreDeltas(state.report, state.previous);

  return (
    <Card className="p-6 rounded-2xl border-slate-100" data-testid="admin-credit-report-panel">
      <div className="flex items-center gap-2 mb-4">
        <div className="w-9 h-9 rounded-xl bg-amber-100 text-amber-700 flex items-center justify-center">
          <TrendingUp size={18} />
        </div>
        <div className="flex-1">
          <h3 className="font-display font-bold text-lg">Credit Report</h3>
          <p className="text-xs text-slate-500">
            {state.total > 0
              ? `${state.total} report${state.total === 1 ? "" : "s"} uploaded by this client`
              : "The client hasn't uploaded a credit report yet"}
          </p>
        </div>
        <Button size="sm" variant="ghost" onClick={load} data-testid="refresh-credit-report">
          <RefreshCcw size={14} />
        </Button>
      </div>

      {loading && <p className="text-sm text-slate-400">Loading…</p>}
      {!loading && !state.report && (
        <div className="rounded-xl border border-dashed border-slate-200 p-8 text-center" data-testid="admin-credit-report-empty">
          <div className="w-12 h-12 rounded-xl bg-slate-100 mx-auto mb-2 flex items-center justify-center text-slate-400">
            <FileX2 size={22} />
          </div>
          <p className="text-sm font-semibold text-slate-600">No credit report uploaded yet</p>
          <p className="text-xs text-slate-400 mt-1">Ask the client to drop their PDF into their Funding Center → My Real Report.</p>
        </div>
      )}

      {!loading && state.report && (
        <CreditReportView report={state.report} theme="light" deltas={deltas} />
      )}
    </Card>
  );
}
